const BYTES_POR_KB = 1024;
const BYTES_POR_MB = BYTES_POR_KB * 1024;

/** Formata o tamanho do PDF para exibição (`1.2 MB`, `640 KB`). */
export function formatarTamanhoArquivo(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '';
  }

  if (bytes >= BYTES_POR_MB) {
    return `${(bytes / BYTES_POR_MB).toFixed(1)} MB`;
  }

  return `${Math.round(bytes / BYTES_POR_KB)} KB`;
}
